import { render, staticRenderFns } from "./menu_item_modal.vue?vue&type=template&id=59b4c596&scoped=true&"
import script from "./menu_item_modal.vue?vue&type=script&lang=js&"
export * from "./menu_item_modal.vue?vue&type=script&lang=js&"
import style0 from "./menu_item_modal.vue?vue&type=style&index=0&id=59b4c596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b4c596",
  null
  
)

export default component.exports